import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { GetChildScheduleParams } from './parentService';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

/**
 * The authenticated parent's merged calendar across every linked child.
 *
 * One request rather than a fan-out: the backend already merges siblings'
 * shared meetings into a single row, which a per-child fan-out could not do.
 */
export function useGetParentCalendar(params?: GetChildScheduleParams, enabled = true) {
  const query = useQuery({
    queryKey: [ParentKey.CALENDAR, params],
    queryFn: () => ParentService.getParentCalendar(params).then((response) => response.data),
    enabled,
  });
  const errorMessage = useErrorMessage(query.error, baseErrorMessages);
  return { ...query, errorMessage };
}
